import { cloneDeep } from "lodash";

import { ApiRoutesItem } from "@/api/routes";

export const SORT_OPTIONS = [
  {
    value: 1,
    label: `Lowest Economy Class Points`,
    fn: (a: ApiRoutesItem, b: ApiRoutesItem) => {
      if (a.points.y < b.points.y) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 2,
    label: `Lowest Economy Premium Class Points`,
    fn: (a: ApiRoutesItem, b: ApiRoutesItem) => {
      if (a.points.w < b.points.w) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 3,
    label: `Lowest Business Class Points`,
    fn: (a: ApiRoutesItem, b: ApiRoutesItem) => {
      if (a.points.j < b.points.j) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 4,
    label: `Lowest First Class Points`,
    fn: (a: ApiRoutesItem, b: ApiRoutesItem) => {
      if (a.points.f < b.points.f) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 5,
    label: `Latest Seen`,
    fn: (a: ApiRoutesItem, b: ApiRoutesItem) => {
      if (a.points.ls > b.points.ls) {
        return -1;
      }

      return 1;
    },
  },
];

export const initialRouteSort = (
  list: ApiRoutesItem[],
  closest_airport: string = ""
): ApiRoutesItem[] => {
  list.sort((a: ApiRoutesItem, b: ApiRoutesItem): number => {
    // Check if last seen date is within one day

    if (
      new Date().getTime() - a.points.ls * 1000 < 43000000 &&
      new Date().getTime() - b.points.ls * 1000 > 43000000
    ) {
      return -1;
    } else if (
      new Date().getTime() - a.points.ls * 1000 > 43000000 &&
      new Date().getTime() - b.points.ls * 1000 < 43000000
    ) {
      return 1;
    }

    return (a.points.f ? a.points.f : Infinity) - (b.points.f ? b.points.f : Infinity);
  });

  var closest_airpots_routes = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].route.split("-")[0] === closest_airport) {
      closest_airpots_routes.push(list[i]);
    }
    if (closest_airpots_routes.length >= 20) {
      break;
    }
  }
  const closest_airpots_routes_shuffled = closest_airpots_routes.sort(() => Math.random() - 0.5);
  const random_closest_airpots_routes = closest_airpots_routes_shuffled.slice(0, 3);
  // Shuffle the first 1000 results
  const shuffled = list.slice(0, 100).sort(() => Math.random() - 0.5);
  list = random_closest_airpots_routes.concat(shuffled.concat(list.slice(100)));
  if(list.length > 500) {
    return list;
  }
  // Remove duplicate routes
  var uniqueArray: any = [];
  for (const item of list) {
    if (!uniqueArray.includes(item)) {
      uniqueArray.push(item);
    }
  }

  return uniqueArray;
};
/**
 * 排序
 */
export const sortFn = (list: ApiRoutesItem[], sortKey?: number): ApiRoutesItem[] => {
  const targetSort = SORT_OPTIONS.find((item) => item.value === sortKey);
  return targetSort?.fn
    ? cloneDeep(list)
        .map((item) => {
          if (!item.points.w) {
            item.points.w = Infinity;
          }
          if (!item.points.y) {
            item.points.y = Infinity;
          }
          if (!item.points.j) {
            item.points.j = Infinity;
          }
          if (!item.points.f) {
            item.points.f = Infinity;
          }
          return item;
        })
        .sort(targetSort?.fn)
        .map((item) => {
          if (item.points.w === Infinity) {
            item.points.w = 0;
          }
          if (item.points.y === Infinity) {
            item.points.y = 0;
          }
          if (item.points.j === Infinity) {
            item.points.j = 0;
          }
          if (item.points.f === Infinity) {
            item.points.f = 0;
          }

          return item;
        })
    : list;
};
